import { OrdemColunaTabela, AriaSort } from "view/component/Tabela/model/OrdemColunaTabela";



export function convertSortIntoColunaConfig(sort: string): OrdemColunaTabela {
  const [nome, ordem] = sort.split(',');
  var ariaOrdem: AriaSort = ordem === 'desc'
    ? AriaSort.Descending
    : AriaSort.Ascending;

  return {
    ordem: ariaOrdem,
    coluna: nome
  }
}